module.exports = __webpack_public_path__ + "img/topDealsBanner1.fc427e6d.jpg";